<img [src]="mapUrl" />
